import { createSelector } from '@reduxjs/toolkit';

import getFiltersInitialSettings from '../helpers/getFiltersInitialSettings';

import configSelector from './config';

/**
 * Получить предустановленные значения фильтров
 */
const filtersInitialSettingsSelector = createSelector(configSelector, config =>
  getFiltersInitialSettings(config),
);

export default filtersInitialSettingsSelector;
